<app-modal #modal class="check-expense-claim-list-modal" [size]="ModalSize.Sm">
  <div class="modal-header">
    <h2 class="modal-title">{{ modalLabel }}</h2>
  </div>
  <div class="modal-body details-view">
    <div class="details-view-results">
      <div class="patient-expense" *ngFor="let expense of claims; let i = index;">
        <div class="badge-wrap">
          <span class="badge" [ngClass]="{'badge-warning': expense.state == 'Pending',
                                  'badge-success': (expense.state == 'AutomatedPaymentApproved' || expense.state == 'Processing' || expense.state == 'Approved'),
                                  'badge-danger': (expense.state == 'Rejected' || expense.state == 'AutomatedPaymentFailed'),
                                  'badge-grey': expense.state == 'Paid'}">
            {{ getBadgeLabel(expense.state) }}
          </span>

          <span class="label" *ngIf="expense.state === 'AutomatedPaymentApproved' && expense.dateApproved">
            on {{ expense.dateApproved | date: 'd MMM yyyy' }} at {{
            expense.dateApproved | date: 'h:mm aaa'
            }}
          </span>

          <span class="label" *ngIf="expense.state === 'Rejected' && expense.dateRejected">
            on {{ expense.dateRejected | date: 'd MMM yyyy' }} at {{
            expense.dateRejected | date: 'h:mm aaa'
            }}
          </span>

          <span class="label" *ngIf="expense.state === 'Paid' && expense.datePaid">
            on {{ expense.datePaid | date: 'd MMM yyyy' }} at {{ expense.datePaid | date: 'h:mm aaa' }}
          </span>
        </div>

        <span class="label submitted-date">
          {{expense.addedByPatient ? 'Submitted by patient on ' : 'Created by administrator on '}} {{ expense.created |
          date:'d MMM yyyy' }} at {{ expense.created | date: 'h:mm aaa' }}
        </span>

        <div class="title-cost-wrap" *ngIf="expense.categoryType == 'Distance'">
          <span class="result-heading title">{{ expense.categoryName }}</span>
          <span class="result-heading cost">
            {{ expense.distanceAmount }} {{ expense.distanceUnit }}
            <span *ngIf="expense.amount > 0"> / {{ expense.currency }} {{ expense.amount | number:'1.2-2' }}</span>
          </span>
        </div>

        <div class="title-cost-wrap" *ngIf="expense.categoryType == 'Value'">
          <span class="result-heading title">
            {{ expense.categoryName }}<span
              *ngIf="!stringHelper.isNullOrEmpty(expense.subCategoryName) && expense.subCategoryName !== 'None'">
              - {{ expense.subCategoryName }}
            </span>
          </span>
          <span class="result-heading cost">
            {{ expense.currency}} <span class="negative-amount"
              *ngIf="expense.subCategoryName === 'Card Preload Redemption'">-</span> {{
            expense.amount |
            number:'1.2-2'
            }}
          </span>
        </div>

        <div class="desc">
          <p *ngIf="expense.notes">{{ expense.notes }}</p>
        </div>

        <p class="rejected-reason orange" *ngIf="expense.underInvestigation">
          <strong>Reason for Investigation:</strong> {{
          expense.reasonForInvestigation
          }}
        </p>

        <p class="rejected-reason" *ngIf="expense.state == 'Rejected'">
          <strong>Rejection Reason:</strong> {{
          expense.rejectionReason
          }}
        </p>
        <app-expense-images [enableImagesManagement]="false" [imagery]="expense.imageUrls"
          [expenseClaimId]="expense.id"></app-expense-images>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-3">
        <app-button text="Close" (clicked)="onClose()" variant="secondary" width="fill" />
      </div>
    </div>
  </div>
</app-modal>
